import store from '@/store';
export default {
    inserted(el, binding) {
        const permissions = store.state.login.permissions;
        // 「其他角色」按钮权限校验
        const { value } = binding;
        if (value && value instanceof Array && value.length > 0) {
            const hasPermission = permissions.some((permi) => {
            return permi === '*:*:*' || value.includes(permi);
        });
        if (!hasPermission) {
            el.parentNode && el.parentNode.removeChild(el);
            // return false;
        }
        } else {
            throw new Error("check perms! Like v-has-permi=\"['system:user:add','system:user:edit']\"");
        }
    }
}
